import React from 'react';
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import { Grid } from '@mui/material';
import { height } from '@mui/system';


const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  height: 60,
  lineHeight: "60px",
}));
const darkTheme = createTheme({ palette: { mode: "dark" } });
const lightTheme = createTheme({ palette: { mode: "light" } });

const Header = ({ category, title }) => (
  // <Box
  //   sx={{
  //     display: "flex",
  //     flexWrap: "wrap",
  //     "& > :not(style)": {
  //       m: 1,
  //       width: 128,
  //       height: 128,
  //     },
  //   }}
  // >
  <div className="flex align-middle">
    {/* <span
      className="text-sm font-extrabold after:tracking-tight text-fg-3 mr-2 md:mr-1 dark:bg-stone-700"
    > */}
    {/* <div className="flex placeholder:text-sm font-extrabold after:tracking-tight text-fg-3 mr-25 md:mr-1 dark:bg-stone-700"> */}
    {/* <Paper
      elevation={2}
      style={{
        width: "fit-content",
        height: 5,
        padding: 16,
        alignItems: "center",
        alignSelf: "center",
      }}
    >
      {category}
    </Paper> */}
    {/* <Grid container spacing={2} sx={{ height: 50 }}>
      <Grid item xs={1} sx={{ height: 50 }}>
        <Item sx={{ height: 20 }}>{category}</Item>
      </Grid>
      <Grid item xs={8}>
        <Item>{title}</Item>
      </Grid>
    </Grid> */}
    {/* </div> */}
    {/* <ThemeProvider theme={MUITheme}> */}
    {/* <div className="bg-stoen-700 p-8">
      <Box
        sx={{
          p: 2,
          bgcolor: "background.default",
          display: "grid",
          gridTemplateColumns: { md: "1fr 1fr" },
          gap: 2,
        }}
      >
        {[0, 1, 2, 3, 4, 6, 8, 12, 16, 24].map((elevation) => (
          <Item key={elevation} elevation={elevation}>
            {`elevation=${elevation}`}
          </Item>
        ))}
      </Box>
    </div> */}
    {/* </ThemeProvider> */}
    <div className="drop-shadow-lg p-3 font-bold italic text-xs text-slate-900 dark:text-slate-200 align-middle">
      {category}
    </div>
    <div className="drop-shadow-lg text-3xl font-extrabold tracking-tighter text-slate-900 dark:text-slate-200">
      {title}{" "}
    </div>
  </div>
  // </Box>
);

export default Header;
